package com.eladfinish.bible.contest.data.analytics

import co.touchlab.stately.collections.ConcurrentMutableMap
import com.eladfinish.bible.contest.analytics.crashlytics.setCrashlyticsCustomKeyPlatform
import com.eladfinish.bible.contest.analytics.crashlytics.setCrashlyticsUserIdPlatform
import com.eladfinish.bible.contest.platform.isDesktop
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.analytics.analytics
import io.github.aakira.napier.Napier

interface FirebaseAnalyticsDataSource {

    fun setUserProperty(key: String, value: String?)

    fun clearUserProperties()

    fun setAnalyticsUserId(userId: String?)

    fun setCrashlyticsUserId(userId: String)

    fun setCrashlyticsCustomKey(key: String, value: String)
}

class FirebaseAnalyticsDataSourceImpl() : FirebaseAnalyticsDataSource {

    private val userProperties = ConcurrentMutableMap<String, String?>()

    override fun setUserProperty(key: String, value: String?) {
        userProperties[key] = value

        // The gitlive Firebase Analytics SDK has no JVM desktop target — its JVM artifact's
        // Firebase.analytics getter is a bare TODO() that throws NotImplementedError the moment
        // it's touched, so skip it on desktop the same way remote config is skipped (see
        // sharedModule).
        if (isDesktop) return

        Firebase.analytics.setUserProperty(key, value.orEmpty()).also {
            Napier.v(tag = TAG, message = "Setting User Property: $key with value: $value")
        }
    }

    override fun clearUserProperties() {
        userProperties.block { map ->
            map.forEach {
                setUserProperty(key = it.key, value = null)
            }
        }
    }

    override fun setAnalyticsUserId(userId: String?) {
        if (isDesktop) return

        Firebase.analytics.setUserId(userId).also {
            Napier.v(tag = TAG, message = "Setting User Analytics ID: userId = $userId")
        }
    }

    override fun setCrashlyticsUserId(userId: String) {
        setCrashlyticsUserIdPlatform(userId)
        Napier.v(tag = TAG, message = "Setting User Crashlytics ID: userId = $userId")
    }

    override fun setCrashlyticsCustomKey(key: String, value: String) {
        setCrashlyticsCustomKeyPlatform(key, value)
        Napier.v(tag = TAG, message = "Setting Crashlytics Custom Key: $key with value: $value")
    }

    private companion object {
        const val TAG = "FIREBASE_ANALYTICS"
    }
}
